import { useBanks } from "./use-banks"
import { useCashoutAccounts } from "./use-cashout-accounts"
import { useCashoutAvailable } from "./use-cashout-available"
import { useIncode } from "../../../hooks/use-incode"

export const useCashoutsAllData = () => {
  const { data: cashoutAccounts, isLoading: isLoadingCashoutAccounts } = useCashoutAccounts()
  const { data: cashoutAvailable, isLoading: isLoadingCashoutAvailable } = useCashoutAvailable()
  const { data: banks, isLoading: isLoadingBanks } = useBanks()
  const incode = useIncode()

  return {
    cashoutAccounts,
    cashoutAvailable,
    banks,
    incode,
    isLoading: isLoadingCashoutAccounts || isLoadingCashoutAvailable || isLoadingBanks || incode.isLoading,
    refetch: () => {
      cashoutAccounts.refetch()
      cashoutAvailable.refetch()
    }
  }
}